module.exports = __webpack_public_path__ + "img/icon_search_black.583b813d.svg";